import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ShoppingCartDto, ShoppingCartItemDto } from 'src/app/core/dtos/dto';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-cart-items',
  templateUrl: './cart-items.component.html',
  styleUrls: ['./cart-items.component.scss']
})
export class CartItemsComponent implements OnChanges {

  @ViewChild('confirmRemoveModal') confirmRemoveModal: ModalComponent;

  @Input() shoppingCart: ShoppingCartDto;
  @Output() removeItem: EventEmitter<number> = new EventEmitter<number>();

  shoppingCartItems: ShoppingCartItemDto[];
  itemIdToRemove: number;
  itemQuantity = new FormGroup({
    quantity: new FormControl()
  });

  constructor(
    private configHelper: ConfigHelper,
  ) {
  }

  ngOnChanges(): void {
    this.shoppingCartItems = this.shoppingCart.shoppingCartItems.map(item => ({
      ...item,
      shortDescription: this.removeInlineStyleProductDescription(item.shortDescription),
      description: this.removeInlineStyleProductDescription(item.description),
      imageUrl: this.configHelper.getProductImageUrl(item.imageUrl)
    }));
  }

  onModalLoad(id: number) {
    this.confirmRemoveModal.open();
    this.itemIdToRemove = id;
  }

  onRemove(id: number) {
    this.removeItem.emit(id);
  }

  removeInlineStyleProductDescription(productDescription: string) {
    if (productDescription?.length) {
      //this will remove all inline styling from the product description
      productDescription = productDescription.replace(new RegExp('style="(.*?)"', 'g'), "");
      productDescription = productDescription.replace(new RegExp('face="(.*?)"', 'g'), "");
      return productDescription;
    }

  }

}
